var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"ck-editor"},[_c('textarea',{attrs:{"id":_vm.editorId,"data-qe-id":_vm.editorId},domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }